// 9fbef606107a605d69c0edbcd8029e5d
import { QUICK_VIEW_ACTION_PATTERN } from '../../../../../constants/reducer.constants';

const SET_QUICK_VIEW = `${QUICK_VIEW_ACTION_PATTERN}SET_QUICK_VIEW`;
const FETCH_QUICK_VIEW = `${QUICK_VIEW_ACTION_PATTERN}FETCH_QUICK_VIEW`;
const OPEN_QUICK_VIEW_MODAL = `${QUICK_VIEW_ACTION_PATTERN}OPEN_QUICK_VIEW_MODAL`;
const CLOSE_QUICK_VIEW_MODAL = `${QUICK_VIEW_ACTION_PATTERN}CLOSE_QUICK_VIEW_MODAL`;
const SET_ITEM_FROM_BAG_INFO = `${QUICK_VIEW_ACTION_PATTERN}SET_ITEM_FROM_BAG_INFO`;
const SET_LOADING_STATE = `${QUICK_VIEW_ACTION_PATTERN}SET_LOADING_STATE`;
const SET_PRODUCT_QV_ID = `${QUICK_VIEW_ACTION_PATTERN}SET_PRODUCT_QV_ID`;
const SET_LOADING_ERROR = `${QUICK_VIEW_ACTION_PATTERN}SET_LOADING_ERROR`;
const UPDATE_APP_TYPE_AND_REDIRECT = 'updateAppTypeAndRedirect';
const FETCH_MODULEX_CONTENT = `${QUICK_VIEW_ACTION_PATTERN}FETCH_MODULEX_CONTENT`;
const SET_MODULEX_CONTENT = `${QUICK_VIEW_ACTION_PATTERN}SET_MODULEX_CONTENT`;
const SET_QUICK_VIEW_PRODUCT_TITLE = `${QUICK_VIEW_ACTION_PATTERN}SET_QUICK_VIEW_PRODUCT_TITLE`;
const SET_MULTIPRODUCT_DETAILS = `${QUICK_VIEW_ACTION_PATTERN}SET_MULTIPRODUCT_DETAILS`;
const SINGLE_TAB_STORE = `${QUICK_VIEW_ACTION_PATTERN}SINGLE_TAB_STORE`;
const QUICK_SINGLE_TAB_STORE = `${QUICK_VIEW_ACTION_PATTERN}QUICK_SINGLE_TAB_STORE`;
const SET_DISABLE_SELECTED_TAB = `${QUICK_VIEW_ACTION_PATTERN}SET_DISABLE_SELECTED_TAB`;
const UPDATE_MINIBAG_CLOSE_STATUS = `${QUICK_VIEW_ACTION_PATTERN}UPDATE_MINIBAG_CLOSE_STATUS`;
const SET_BRAND_NAME = `${QUICK_VIEW_ACTION_PATTERN}SET_BRAND_NAME`;
const SET_TOTAL_PRICES = `${QUICK_VIEW_ACTION_PATTERN}SET_TOTAL_PRICES`;
const PREVIOUS_SCREEN = `${QUICK_VIEW_ACTION_PATTERN}PREVIOUS_SCREEN`;
const PREVIOUS_SCREEN_ID = `${QUICK_VIEW_ACTION_PATTERN}PREVIOUS_SCREEN_ID`;
const SET_PLP_DATA_FOR_QUICKVIEW = `${QUICK_VIEW_ACTION_PATTERN}SET_PLP_DATA_FOR_QUICKVIEW`;
const SET_SLP_DATA_FOR_QUICKVIEW = `${QUICK_VIEW_ACTION_PATTERN}SET_SLP_DATA_FOR_QUICKVIEW`;
const SET_QUICK_VIEW_PRODUCT_IMAGE = `${QUICK_VIEW_ACTION_PATTERN}SET_QUICK_VIEW_PRODUCT_IMAGE`;
const SET_ITEM_DATA_FOR_QUICKVIEW = `${QUICK_VIEW_ACTION_PATTERN}SET_ITEM_DATA_FOR_QUICKVIEW`;
const RESET_BIRTHDAY_MODULE_VALUE = `${QUICK_VIEW_ACTION_PATTERN}RESET_BIRTHDAY_MODULE_VALUE`;
const RESET_QUICK_VIEW_PRODUCT = `${QUICK_VIEW_ACTION_PATTERN}RESET_QUICK_VIEW_PRODUCT`;
const SAVE_DATA_FOR_PDP = `${QUICK_VIEW_ACTION_PATTERN}SAVE_DATA_FOR_PDP`;
const RESET_PDP_QUICK_VIEW_PRODUCT = `${QUICK_VIEW_ACTION_PATTERN}RESET_PDP_QUICK_VIEW_PRODUCT`;
const SET_SELECTED_PRODUCT_DATA = `${QUICK_VIEW_ACTION_PATTERN}SET_SELECTED_PRODUCT_DATA`;
const SHOW_RATING_VIEW = 'SHOW_RATING_VIEW';
const GET_DATA_ON_NEW_FITS_CLICK = `${QUICK_VIEW_ACTION_PATTERN}GET_DATA_ON_NEW_FITS_CLICK`;
const UPDATE_DATA_ON_NEW_FITS_CLICK = `${QUICK_VIEW_ACTION_PATTERN}UPDATE_DATA_ON_NEW_FITS_CLICK`;

const QUICK_VIEW_CONSTANT = {
  SET_QUICK_VIEW,
  FETCH_QUICK_VIEW,
  OPEN_QUICK_VIEW_MODAL,
  CLOSE_QUICK_VIEW_MODAL,
  SET_ITEM_FROM_BAG_INFO,
  SET_LOADING_STATE,
  SET_PRODUCT_QV_ID,
  SET_LOADING_ERROR,
  UPDATE_APP_TYPE_AND_REDIRECT,
  FETCH_MODULEX_CONTENT,
  SET_MODULEX_CONTENT,
  SET_QUICK_VIEW_PRODUCT_TITLE,
  SET_QUICK_VIEW_PRODUCT_IMAGE,
  SET_MULTIPRODUCT_DETAILS,
  SINGLE_TAB_STORE,
  QUICK_SINGLE_TAB_STORE,
  SET_DISABLE_SELECTED_TAB,
  UPDATE_MINIBAG_CLOSE_STATUS,
  SET_BRAND_NAME,
  SET_TOTAL_PRICES,
  PREVIOUS_SCREEN,
  PREVIOUS_SCREEN_ID,
  SET_PLP_DATA_FOR_QUICKVIEW,
  SET_SLP_DATA_FOR_QUICKVIEW,
  SET_ITEM_DATA_FOR_QUICKVIEW,
  RESET_BIRTHDAY_MODULE_VALUE,
  RESET_QUICK_VIEW_PRODUCT,
  SAVE_DATA_FOR_PDP,
  RESET_PDP_QUICK_VIEW_PRODUCT,
  SET_SELECTED_PRODUCT_DATA,
  SHOW_RATING_VIEW,
  GET_DATA_ON_NEW_FITS_CLICK,
  UPDATE_DATA_ON_NEW_FITS_CLICK,
};

export default QUICK_VIEW_CONSTANT;
